import { useEffect, useState } from "react";

const navLinks = [
  { href: "#home", label: "首页" },
  { href: "#ranking", label: "人气榜单" },
  { href: "#category", label: "题材分类" },
  { href: "#latest", label: "最新更新" },
  { href: "#feedback", label: "读者口碑" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16 md:h-18">
        <a href="#home" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
            <i className="ri-magic-line text-lg"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">
            奇妙<span className="text-primary-500">漫画</span>
          </span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {navLinks.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="text-sm text-foreground-700 transition-colors hover:text-primary-500 whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#subscribe"
            className="rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            立即追漫
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200/70 bg-background-100 text-foreground-950 lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50/98 px-4 py-4">
          <ul className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-500"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="mt-2 block rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                立即追漫
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}